export const BASIC_INFO_ROW_CELL_BORDER_CLASS = "border-x-0 border-t-0 border-b border-gray-200";
